import { CodeComponent, codeTemplate } from './Code';
import styles from './Code.styles.scss';
export const codeDefinition = {
    baseName: 'code',
    template: codeTemplate,
    styles,
};
export const chameleonCode = CodeComponent.compose(codeDefinition);
